import React from "react";
import { Row, TD } from "./styles";

// Icons
import { ReactComponent as ConnectionIcon } from "assets/icons/svg/ICONOS-32PX-FASE-2b.1-GENERIC-09.svg";
import { ReactComponent as OrdersIcon } from "assets/icons/svg/ICONOS-32PX-FASE-2b.1-GENERIC-15.svg";
import { ReactComponent as CapacityIcon } from "assets/icons/svg/ICONOS-32PX-FASE-2b.1-GENERIC-12.svg";

const MenuTableRow = ({
  item,
  color,
  isRowSelected,
  onSelectRow,
  onClickDetail,
}) => {
  const { id, number } = item;

  return (
    <React.Fragment>
      <Row className={isRowSelected} colors={color}>
        <TD width={30} onClick={() => onSelectRow(number)} className="cursor">
          {number}
        </TD>
        <TD>
          <ConnectionIcon width="40" height="40" />
        </TD>
        <TD
          width={20}
          className="cursor"
          onClick={() => onClickDetail(number, id)}
        >
          <OrdersIcon width="40" height="40" />
        </TD>
        <TD>
          <CapacityIcon width="40" height="40" />
        </TD>
      </Row>
    </React.Fragment>
  );
};

export default React.memo(MenuTableRow);
